// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo[data-v-767d21cc],.logo-button[data-v-767d21cc]{box-shadow:0 2px 4px -1px rgba(0,0,0,.2),0 1px 10px rgba(0,0,0,.12),0 4px 5px rgba(0,0,0,.14)!important}.logo-button[data-v-767d21cc]{border-radius:0!important;font-family:FrankfurterNetto,sans-serif;height:32px;line-height:1;margin-left:15px;padding:0;width:130px}@media(max-width:991.98px){.logo-button[data-v-767d21cc]{height:24px;min-width:97px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
